import React from "react";
import { Updater, async, fromJSX, Widget } from "widgets-for-react";
import { InviewProps } from "../blocksState";
import { ChildDossiersBlockLayout } from "./childDossiersBlockLayout";
import { ChildDossiers, ChildDossiersBlockState } from "./childDossiersBlockState";

export type ChildDossiersBlock = {
    index: number
    inview?: InviewProps
    title?: React.ReactNode
    childrenState: ChildDossiersBlockState
}

export const childDossiersBlockWidget = (
    block: ChildDossiersBlock
): Widget<Updater<ChildDossiersBlockState>> =>
async<ChildDossiers>(block.childrenState, (childDossiers) =>
    fromJSX(() => <ChildDossiersBlockLayout {...block} children={childDossiers} />)
  )
